"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderPaymentSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.OrderPaymentSchema = __1.BaseSchema.extend({
    transactionAmount: __1.MoneySchema.optional(),
    approvedAt: zod_1.z.coerce.date().optional(),
    channelPaymentId: __1.ShortStringSchema.optional(),
    channelPaymentMethod: __1.ShortStringSchema.optional(),
    channelPaymentStatus: __1.ShortStringSchema.optional(),
    channelPaymentType: __1.ShortStringSchema.optional(),
    refundedAmount: __1.MoneySchema.optional(),
    status: zod_1.z.nativeEnum(__1.OrderPaymentStatus).optional(),
    type: zod_1.z.nativeEnum(__1.OrderPaymentType).optional(),
});
//# sourceMappingURL=order-payment.js.map